export default __webpack_public_path__ + "0c1bd99621ec087a7a95fafcc99d73a1.png";